module.exports = __webpack_public_path__ + "media/wyposazenie/komfort@3x-c87595a7.svg";